module.exports = __webpack_public_path__ + "static/media/Download_icon.e010697d.svg";